import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';

const AsyncLogin = Load(
  () =>
    import(
      /* webpackChunkName: "login-screen" */ 'modules/authentication/containers/LoginScreen'
    ),
);
const AsyncSignUp = Load(
  () =>
    import(
      /* webpackChunkName: "signup-screen" */ 'modules/authentication/containers/SignupScreen'
    ),
);
const AsyncBrandVideoModal = Load(
  () =>
    import(/* webpackChunkName: "brand-video" */ 'components/BrandVideoModal'),
);
const AsyncDatePickerContainer = Load(
  () =>
    import(
      /* webpackChunkName: "navbar-filters" */ 'modules/homescreen/containers/DatePicker'
    ),
);
const AsyncPeopleSelector = Load(
  () =>
    import(
      /* webpackChunkName: "navbar-filters" */ 'modules/homescreen/containers/PeopleSelector'
    ),
);
const AsyncLocalSpeaksModal = Load(
  () =>
    import(
      /* webpackChunkName: "navbar-filters" */ 'components/LocalSpeaksModal'
    ),
);
const AsyncMoreFilterContainer = Load(
  () =>
    import(
      /* webpackChunkName: "navbar-filters" */ 'modules/homescreen/containers/MoreFilterContainer'
    ),
);
const AsyncStartCourseModalOverlay = Load(
  () =>
    import(
      /* webpackChunkName: "learning-center" */ 'modules/host-learning-center/components/ModalRoutes/StartCourseModalOverlay'
    ),
);
const AsyncCompletedCourseModalOverlay = Load(
  () =>
    import(
      /* webpackChunkName: "learning-center" */ 'modules/host-learning-center/components/ModalRoutes/CompletedCourseModalOverlay'
    ),
);

const ModalOverlays = [
  <Route
    key="brand-video"
    path={`${basePath}/brand-video/`}
    element={<AsyncBrandVideoModal />}
  />,
  <Route
    key="filter-date"
    path={`${basePath}/filter/date/`}
    element={<AsyncDatePickerContainer />}
  />,
  <Route
    key="filter-guests"
    path={`${basePath}/filter/guests/`}
    element={<AsyncPeopleSelector />}
  />,
  <Route
    key="filter-languages"
    path={`${basePath}/filter/languages/`}
    element={<AsyncLocalSpeaksModal />}
  />,
  <Route
    key="filter-more"
    path={`${basePath}/filter/more/`}
    element={<AsyncMoreFilterContainer />}
  />,
  <Route
    key="learning-center-course-start"
    path={`${basePath}/learning-center/course/start/:id/`}
    element={<AsyncStartCourseModalOverlay />}
  />,
  <Route
    key="learning-center-course-completed"
    path={`${basePath}/learning-center/course/completed/:id/`}
    element={<AsyncCompletedCourseModalOverlay />}
  />,
  <Route key="login" path={`${basePath}/login/`} element={<AsyncLogin />} />,
  <Route key="signup" path={`${basePath}/signup/`} element={<AsyncSignUp />} />,
].filter(Boolean);

export default ModalOverlays;
